export default __webpack_public_path__ + "static/media/scrollDown.svg";